import { FC, useState } from 'react'
import { IconPaths, ModalSize } from '_metronic/helpers'
import { ItemPrescricao } from '../../core/montagem/itens'
import { PrescricaoList } from '../../core/_model'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { useRotulos } from '../comum/useRotulos'
import { CartaoHistorico } from './CartaoHistorico'
import { TodasPrescricoes } from './TodasPrescricoes'
import { Button, useModal } from 'app/components'

const QUANTIDADE_ULTIMAS = 4

type IProps = {
  prescricoes: PrescricaoList[]
  carregando: boolean
  nomePaciente?: string
  onAdicionar: (itens: ItemPrescricao[]) => number
}

/** Últimas prescrições do paciente, recolhidas no fim da tela, com "Ver todas". */
export const UltimasPrescricoes: FC<IProps> = ({
  prescricoes,
  carregando,
  nomePaciente,
  onAdicionar,
}) => {
  const { t } = useRotulos()
  const { showModal } = useModal()
  const [aberta, setAberta] = useState(false)

  const verTodas = () =>
    showModal({
      title: t('prescricao.historico.modal_titulo', { paciente: nomePaciente ?? '' }),
      content: <TodasPrescricoes prescricoes={prescricoes} onAdicionar={onAdicionar} />,
      size: ModalSize.ExtraLarge,
      contentClassName: styles.tema,
    })

  if (carregando || prescricoes.length === 0) return null
  const ultimas = prescricoes.slice(0, QUANTIDADE_ULTIMAS)

  return (
    <section className='card card-bordered mb-5' aria-labelledby='historico-ultimas'>
      <div className='card-header align-items-center border-0'>
        <h2 id='historico-ultimas' className='card-title m-0'>
          <Button
            className={`${styles.botaoTexto} d-flex align-items-center gap-2 fs-5 fw-bold`}
            ariaExpanded={aberta}
            ariaControls='historico-ultimas-lista'
            onClick={() => setAberta((valor) => !valor)}
            unstyled
          >
            <Icone icone={IconPaths.ArrowRight} className={aberta ? styles.chevronAberto : ''} />
            {t('prescricao.historico.ultimas', {
              quantidade: prescricoes.length,
              data: prescricoes[0].dataFormatada,
            })}
          </Button>
        </h2>
        <Button
          className='btn-link p-0 fw-semibold text-primary text-decoration-underline'
          onClick={verTodas}
        >
          {t('prescricao.historico.ver_todas')}
        </Button>
      </div>
      {aberta && (
        <div id='historico-ultimas-lista' className='card-body pt-0'>
          <p className={`fs-7 ${styles.textoSecundario}`}>{t('prescricao.historico.so_suas')}</p>
          <div className='row g-4'>
            {ultimas.map((prescricao) => (
              <div key={prescricao.id} className='col-md-6 col-xxl-3'>
                <CartaoHistorico prescricao={prescricao} mostrarItens onAdicionar={onAdicionar} />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  )
}
